import { render, staticRenderFns } from "./EditPartnerCopilotModal.vue?vue&type=template&id=71a29556&lang=pug&"
import script from "./EditPartnerCopilotModal.vue?vue&type=script&lang=js&"
export * from "./EditPartnerCopilotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports